import { toast } from 'react-toastify';
import SpinnerWithProgress from './SpinnerWithProgress';

// Show a new toast
export const showProgressToast = (toastId, message = "Downloading...", progress = 0) => {
    toast.info(<SpinnerWithProgress progress={progress} message={message} />, {
      toastId,
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      hideProgressBar: true,
      icon: false,
    });
  };
  
  // Update specific toast by ID
  export const updateProgressToast = (toastId, progress, message = "Downloading...") => {
    toast.update(toastId, {
      render: <SpinnerWithProgress progress={progress} message={message} />,
    });
  };
  
  // Mark specific toast as complete
  export const completeProgressToast = (toastId, message = "Download Complete") => {
    toast.update(toastId, {
      render: <SpinnerWithProgress progress={100} message={message} />,
      autoClose: 2000,
      closeOnClick: true,
    });
  };
  
  // Dismiss specific toast
  export const dismissProgressToast = (toastId) => toast.dismiss(toastId);
  